// import React from 'react'
// import { Toolbar,Grid,Button,Box,Link} from '@mui/material'
// import {styled} from '@mui/material/styles';
// import logo from '../../../../assets/images/logo.png';


// const HeaderToolbar=styled(Toolbar)(
//   ({theme})=> `
//   background-color:${theme.palette.primaryTheme.shade07};
//   width:100vw;
//   height:64px;
//   position:fixed;
//   z-index:999;
//   ${theme.breakpoints.up('mobile')}{
//     min-height:64px;
//   }
//   `
// )

// /**
//  * 
//  * @param {showLogin} props: it will used to toggle between Login and Register button in the flow 
//  * @returns The main header component for the login/registerflow
//  */

// function Header(props) {
//   return (
//     <div>
//         <HeaderToolbar >
//         <Grid  container >
//           <Grid item mobile={6} tablet={6} laptop={6} >
//             <Box display="flex" justifyContent="flex-start">
//               <Link href="/landing" variant="secondaryLink"  target="_blank" rel="noopener noreferrer">
//                 <img src={logo} alt="Vtrender Logo" width={120} height={30}/>
//               </Link>
//             </Box>
//         </Grid>
//         <Grid item mobile={6} tablet={6} laptop={6} >
//             <Box display="flex" justifyContent="flex-end" alignItems={"center"}>
//                 {props.showIntro?
//                   <Button variant="outlined" href="/info-manual" sx={{mr:2}}>
//                       Info Manual
//                   </Button>:
//                   <></>
//                 }
//                 <Button variant="outlined" href="/pricing" sx={{mr:2}}>
//                     Pricing
//                 </Button>
//                 {props.showLogin?
//                 <Button  variant="outlined" href="/login" sx={{mr:2}}>
//                     Login
//                 </Button>:
//                 <Button variant="outlined" href="/register" sx={{mr:2}}>
//                     Register
//                 </Button>
//                 }
            
//               </Box>
//               </Grid>
//         </Grid>
//         </HeaderToolbar>
      
//     </div>
//   )
// }

// export default Header


import React, { useState, useEffect } from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';
import '../../../../components/landing/sections/Navbar.css';
import logo from '../../../../assets/images/logo.png';
// import independenceDayPricing from '../../../../assets/images/independence_day.jpeg';
import independenceDayPricing from '../../../../assets/images/diwali_offer_button.jpeg';
import NewLoginModal from '../../../../components/landing/sections/LoginPopupNew';
import InfoIcon from '@mui/icons-material/Info';
import RupeeIcon from '@mui/icons-material/CurrencyRupee';
import HelpIcon from '@mui/icons-material/Article';
import OndemandVideoIcon from '@mui/icons-material/OndemandVideo';
import LocalOfferIcon from '@mui/icons-material/LocalOffer';
import ToolsWalkthroughPopup from '../../../dashboard/components/tools_walkthrough_pop_up';
// import { TEXT_MSGS } from '../../../../common/utility/constant';



const Header = (props) => {
  const [isScrolled, setIsScrolled] = useState(false);
  const [showLoginPopup, setShowLoginPopup] = useState(false);
  const [showToolsWalkthroughPopup, setShowToolsWalkthroughPopup] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  // const [loginMsg,setLoginMsg]=useState(TEXT_MSGS.LOGIN_POPUP_MSG);
  
  const navigate = useNavigate();

  const openLoginPopup = (value) => {
    setShowLoginPopup(value);
  }

  const toggleMobileMenu = () => {
    setIsMobileMenuOpen(!isMobileMenuOpen);
  }

  const closeMobileMenu = () => {
    setIsMobileMenuOpen(false);
  }

  const handleNavigation = (path) => {
    navigate(path);
    closeMobileMenu();
  }

  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 50);
    };

    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <div>
      <nav className={`navbar ${isScrolled ? 'navbar-scrolled' : ''}`}>
        <div className="navbar-container">
          {/* Logo Section */}
        <motion.div
  className="navbar-logo-centered"
  transition={{ type: "spring", stiffness: 400, damping: 10 }}
>
  <img
    src={logo}
    alt="Vtrender Logo"
    onClick={() => navigate('/landing')}
    style={{
      height: '28px',
      width: 'auto',
      maxHeight: '28px',
      objectFit: 'contain',
      display: 'block',
      pointerEvents: 'auto',
      cursor: 'pointer',
    }}
  />
</motion.div>

          <motion.button
            className="navbar-sale-banner"
            onClick={() => navigate('/pricing')}
            whileTap={{ scale: 0.98 }}
            aria-label="View Independence Day Sale pricing"
          >
            <img
              src={independenceDayPricing}
              alt="Independence Day Sale"
            />
          </motion.button>

          {/* Hamburger Menu for Mobile */}
          <div className={`hamburger-menu ${isMobileMenuOpen ? 'active' : ''}`} onClick={toggleMobileMenu}>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
            <div className="hamburger-line"></div>
          </div>

          {/* Navigation Buttons - Hidden on Mobile */}
          <div className="navbar-buttons">
            {/* <motion.button
              className="navbar-btn navbar-btn-offer"
              onClick={() => navigate('/may-reset')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              May Reset&nbsp;
              <LocalOfferIcon sx={{ml:1, width:"18px",height:"18px"}}/>
            </motion.button> */}
            <motion.button
              className="navbar-btn navbar-btn-secondary"
              onClick={() => navigate('/pricing')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Pricing
              <RupeeIcon sx={{ml:1, width:"18px",height:"18px"}}/>
            </motion.button>
            <motion.button
              className="navbar-btn navbar-btn-secondary"
              onClick={() => setShowToolsWalkthroughPopup(true)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Tools Walkthrough
              <OndemandVideoIcon sx={{ml:1, width:"18px",height:"18px"}}/>
            </motion.button>
            <motion.button
              className="navbar-btn navbar-btn-secondary"
              onClick={() => navigate('/info-manual')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              User Manual
              <HelpIcon sx={{ml:1, width:"18px",height:"18px"}}/>
            </motion.button>
            {props.dontShowGlossary? <></>
            : <motion.button
              className="navbar-btn navbar-btn-secondary"
              onClick={() => navigate('/glossary')}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Glossary
              <InfoIcon sx={{ml:1, width:"18px",height:"18px"}}/>
            </motion.button>}
            {props.showBoth == undefined || props.showBoth ? (
              <>
                <motion.button
                  className="navbar-btn navbar-btn-primary"
                  onClick={() => navigate('/register')}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  Register
                </motion.button>
                <motion.button
                  className="navbar-btn navbar-btn-primary"
                  onClick={() => openLoginPopup(true)}
                  whileHover={{ scale: 1.05 }}
                  whileTap={{ scale: 0.95 }}
                  transition={{ type: "spring", stiffness: 400, damping: 10 }}
                >
                  Login
                </motion.button>
              </>
            ) : props.showLoginPopUp ? (
              <motion.button
                className="navbar-btn navbar-btn-primary"
                onClick={() => openLoginPopup(true)}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                Login
              </motion.button>
            ) : props.showLogin ? (
              <motion.button
                className="navbar-btn navbar-btn-primary"
                onClick={() => navigate('/login')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                Login
              </motion.button>
            ) : (
              <motion.button
                className="navbar-btn navbar-btn-primary"
                onClick={() => navigate('/register')}
                whileHover={{ scale: 1.05 }}
                whileTap={{ scale: 0.95 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                Register
              </motion.button>
            )}
          </div>
        </div>
      </nav>

      {/* Mobile Menu Overlay */}
      <div className={`mobile-menu-overlay ${isMobileMenuOpen ? 'active' : ''}`}>
        <div className="mobile-menu-content">
          {/* <motion.button
            className="mobile-menu-btn navbar-btn-offer"
            onClick={() => handleNavigation('/may-reset')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <LocalOfferIcon sx={{width:"20px",height:"20px"}}/>
            May Reset Offer
          </motion.button> */}

          <motion.button
            className="mobile-menu-btn navbar-btn-secondary"
            onClick={() => handleNavigation('/pricing')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <RupeeIcon sx={{width:"20px",height:"20px"}}/>
            Pricing
          </motion.button>
          
          <motion.button
            className="mobile-menu-btn navbar-btn-secondary"
            onClick={() => {
              setShowToolsWalkthroughPopup(true);
              closeMobileMenu();
            }}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <OndemandVideoIcon sx={{width:"20px",height:"20px"}}/>
            Tools Walkthrough
          </motion.button>

          <motion.button
            className="mobile-menu-btn navbar-btn-secondary"
            onClick={() => handleNavigation('/info-manual')}
            whileHover={{ scale: 1.02 }}
            whileTap={{ scale: 0.98 }}
            transition={{ type: "spring", stiffness: 400, damping: 10 }}
          >
            <HelpIcon sx={{width:"20px",height:"20px"}}/>
            User Manual
          </motion.button>
          
          {!props.dontShowGlossary && (
            <motion.button
              className="mobile-menu-btn navbar-btn-secondary"
              onClick={() => handleNavigation('/glossary')}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              <InfoIcon sx={{width:"20px",height:"20px"}}/>
              Glossary
            </motion.button>
          )}
          
          {props.showBoth == undefined || props.showBoth ? (
            <>
              <motion.button
                className="mobile-menu-btn navbar-btn-primary"
                onClick={() => handleNavigation('/register')}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                Register
              </motion.button>
              <motion.button
                className="mobile-menu-btn navbar-btn-primary"
                onClick={() => {
                  openLoginPopup(true);
                  closeMobileMenu();
                }}
                whileHover={{ scale: 1.02 }}
                whileTap={{ scale: 0.98 }}
                transition={{ type: "spring", stiffness: 400, damping: 10 }}
              >
                Login
              </motion.button>
            </>
          ) : props.showLoginPopUp ? (
            <motion.button
              className="mobile-menu-btn navbar-btn-primary"
              onClick={() => {
                openLoginPopup(true);
                closeMobileMenu();
              }}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Login
            </motion.button>
          ) : props.showLogin ? (
            <motion.button
              className="mobile-menu-btn navbar-btn-primary"
              onClick={() => handleNavigation('/login')}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Login
            </motion.button>
          ) : (
            <motion.button
              className="mobile-menu-btn navbar-btn-primary"
              onClick={() => handleNavigation('/register')}
              whileHover={{ scale: 1.02 }}
              whileTap={{ scale: 0.98 }}
              transition={{ type: "spring", stiffness: 400, damping: 10 }}
            >
              Register
            </motion.button>
          )}
        </div>
      </div>

      {showLoginPopup?
        <NewLoginModal open={true} onClose={()=>setShowLoginPopup(false)}></NewLoginModal>  :
        <></>}
      {showToolsWalkthroughPopup ? (
        <ToolsWalkthroughPopup open={true} onClose={() => setShowToolsWalkthroughPopup(false)} />
      ) : (
        <></>
      )}
    </div>
  );
};

export default Header;
